<template>
  <div class="page">
    <div style="display:none" v-title>检测报告</div>
    <template v-if="!noRights">
      <div class="report-main">
        <span class="register-favor" :style="detail.image"></span>
        <div class="detail-info">
          <div class="flex">
            <div class="flex-1">
              <span class="option-key">部位</span>
              <span class="option-value ellipsis">{{detail.parts || '未知'}}</span>
            </div>
            <div class="flex-1">
              <span class="option-key">症状</span>
              <span class="option-value ellipsis">{{detail.items || '未知'}}</span>
            </div>
          </div>
          <div class="flex">
            <div class="flex-1">
              <span class="option-key">类别</span>
              <span class="option-value ellipsis">{{detail.type || '未知'}}</span>
            </div>
            <div class="flex-1">
              <span class="option-key">级别</span>
              <span class="option-value ellipsis">{{detail.level || '未知'}}</span>
            </div>
          </div>
        </div>
        <div class="detal-useful">
          <h3>成因：</h3>
          <p>{{detail.intro || '未知'}}</p>
          <h3>建议：</h3>
          <p>{{detail.suggest || '未知'}}</p>
          <h3>用药方法：</h3>
          <p>{{detail.personal || '未知'}}</p>
          <h3>评分：<span> {{detail.value || '暂无'}}</span></h3>
        </div>
      </div>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ReportDetail',
  data () {
    return {
      detail: {},
      noRights: false
    }
  },
  created () {
    let checkid = this.$route.query.checkid
    let dataid = this.$route.query.dataid
    let params = {
      checkid: checkid,
      dataid: dataid
    }
    // 报告信息
    this.$axios.get('/Index/Doctor/CheckData', { params: params }).then((response) => {
      if (response.data.code !== 1000) {
        this.noRights = true
      } else {
        this.detail = response.data.data[0]
        this.detail.image = this.detail.image ? 'background-image: url("' + this.detail.image + '")' : ''
      }
    }).catch(function () {})
  }
}
</script>
<style lang="stylus" scoped>
.page
  position relative
  margin 0 auto
  width 720px
.register-favor
  display block
  margin 0 auto
  width 409px
  height 309px
  background-image url('../assets/images/no-img.png')
  background-repeat no-repeat
  background-size 100% auto
  background-position center center
  background-color #e8e8e8
.report-main
  width 702px
  margin 20px 9px 38px 9px
  padding 55px 27px 50px 27px
  background-color #fafafa
  border-radius 20px
  box-shadow 0 0 5px rgba(207,207,207,.7)
  z-index 1
.detail-info
  margin-top 55px
  padding-left 50px
  padding-right 50px
  border-bottom: 1px solid #c9c9c9; /*no*/
.option-key
  position relative
  display inline-block
  margin-bottom 22px
  font-size: 25px; /*px*/
  color #333333
  width 80px
  text-align justify
  line-height 0
  text-align-last justify
  &:after
    position absolute
    right -20px
    top 0
    content '：'
    font-size: 25px; /*px*/
    color #333333
.option-value
  margin-bottom 22px
  display inline-block
  width 180px
  vertical-align top
  line-height 120%
  font-size: 25px; /*px*/
  color #666666
  padding-left 15px
.detal-useful
  margin-top 38px
  padding-left 20px
  padding-right 20px
  h3
    font-size: 27px; /*px*/
    color #333333
    span
      font-size: 25px; /*px*/
      color #666666
  p
    font-size: 25px; /*px*/
    color #666666
    line-height 130%
    margin-top 10px
    margin-left 65px
    margin-bottom 60px
    word-wrap break-word
</style>



// WEBPACK FOOTER //
// src/pages/ReportDetail.vue